import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Spinner } from 'react-bootstrap';

const ProtectedRoute = ({ children }) => {
    const { token, userDetail, loading } = useSelector((state) => state.auth);
    
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (!userDetail) {
        return (
            <div className="vh-100 w-100 d-flex align-items-center justify-content-center bg-light">
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (!userDetail.isVerified) {
        return <Navigate to="/onboarding/verify-notice" replace />;
    }

    if (!userDetail.hasCompletedOnboarding || userDetail.onboardingStep < 2) {
        return <Navigate to="/onboarding/setup-business" replace />;
    }
    
    return children;
};

export default ProtectedRoute;
